import { FormEvent, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { auth } from "../api/client";
import { useAuth } from "../auth/AuthContext";
import BBrand from "../components/b/BBrand";
import BBtn from "../components/b/BBtn";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const [config, setConfig] = useState<{ allow_registration: boolean; first_user: boolean } | null>(null);

  useEffect(() => {
    auth.config().then(setConfig).catch(() => setConfig({ allow_registration: false, first_user: false }));
  }, []);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await register(email, password, fullName);
      navigate("/app/connections", { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : "Sign up failed");
    } finally {
      setSubmitting(false);
    }
  }

  const closed = config && !config.allow_registration;

  return (
    <div className="auth-card-wrap">
      <div className="brand-auth">
        <BBrand to="/" />
      </div>
      <div className="auth-card">
        <h1>{config?.first_user ? "Set up Set & Ledger" : "Create an account"}</h1>
        <p className="auth-sub">
          {config?.first_user
            ? "You're the first user, so this account will be the administrator."
            : "Start capturing receipts from your inbox in minutes."}
        </p>

        {error && <div className="auth-error">{error}</div>}

        {closed ? (
          <div className="auth-error">Sign-ups are closed on this server. Ask an administrator for an account.</div>
        ) : (
          <form onSubmit={handleSubmit} className="auth-form">
            <label>
              Full name
              <input type="text" autoFocus value={fullName} onChange={(e) => setFullName(e.target.value)} />
            </label>
            <label>
              Email
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
            </label>
            <label>
              Password
              <input
                type="password"
                required
                minLength={8}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </label>
            <BBtn type="submit" full disabled={submitting} style={{ marginTop: 8 }}>
              {submitting ? "Creating account…" : "Create account"}
            </BBtn>
            <p className="auth-legal">
              By creating an account, you agree to the <Link to="/terms">Terms of Service</Link> and{" "}
              <Link to="/privacy">Privacy Policy</Link>.
            </p>
          </form>
        )}

        <p className="auth-foot">
          Already have an account? <Link to="/login">Log in</Link>
        </p>
      </div>
    </div>
  );
}
